export default __webpack_public_path__ + "static/1051-a52bbd6b99a9c39002182543d16ccbd9.gif";